/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8ad3e69957c35b33075c2290c9879a73b117266c";
